<template>
  <div class="message-body" :class="[senderType == 'agent' ? 'color-theme-default' : '']">
    <a :href="file.url | absURL" target="_blank">
      <div class="file-name" :title="file.name"><v-icon name="paperclip" scale="0.9" /> {{ file.name }}</div>
    </a>
  </div>
</template>

<script>
export default {
  props: ['file', 'senderType']
}
</script>
